export default __webpack_public_path__ + "static/floor1_image4-sp-9fac4661c2635d1d3ffa42d882b06fcb.png";